var React = require('react');

function ArrowAltToTop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M24 32h336a23.94 23.94 0 0 1 24 23.88V72a23.94 23.94 0 0 1-23.88 24H24A23.94 23.94 0 0 1 0 72.12V56a23.94 23.94 0 0 1 23.88-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M232.11 480H152a24 24 0 0 1-24-24V320H40c-17.82 0-26.73-21.51-14.12-34.11l152.45-152.26a19.4 19.4 0 0 1 27.34 0l152.42 152.23C370.7 298.46 361.79 320 344 320h-87.83v136a24 24 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

ArrowAltToTop.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowAltToTop;

ArrowAltToTop.default = ArrowAltToTop;
